import { apiRequest, investmentEntityRequest } from '@utils/request';
import { ReitElementApi, ReitsStrategyTotals, WeightedReitElementApi } from 'types/reit-element';
import ReitElement from '@classes/ReitElement';

export async function getAllReitElements(): Promise<Array<ReitElement>> {
	const response = await apiRequest.get(`/reit-elements`);
	return response.data.map((reitElementFromApi: ReitElementApi) => new ReitElement(reitElementFromApi));
}

export async function getReitElementsForEntity(): Promise<Array<ReitElement>> {
	const response = await investmentEntityRequest.get(`/portfolio/reit-elements`);
	return response.data.map(
		(weightedReitElement: WeightedReitElementApi) =>
			new ReitElement(weightedReitElement.reitElement, weightedReitElement.weightedAllocation)
	);
}

export async function getReitElementsForReit(reitId: string): Promise<Array<ReitElement>> {
	const response = await apiRequest.get(`/reits/${reitId}/reit-elements`);
	return response.data.map(
		(weightedReitElement: WeightedReitElementApi) =>
			new ReitElement(weightedReitElement.reitElement, weightedReitElement.weightedAllocation)
	);
}

export async function getReitElementsForPlan(planId: string): Promise<Array<ReitElement>> {
	const response = await apiRequest.get(`/ria/${planId}/reit-elements`);
	return response.data.map(
		(weightedReitElement: WeightedReitElementApi) =>
			new ReitElement(weightedReitElement.reitElement, weightedReitElement.weightedAllocation)
	);
}

export async function getReitElement(reitElementId: string): Promise<ReitElement> {
	const response = await apiRequest.get(`/reit-elements/${reitElementId}`);
	return response.data;
}

export async function getStrategyTotals(): Promise<ReitsStrategyTotals> {
	const response = await apiRequest.get(`/reit-elements/strategy-totals`);
	return response.data;
}

export async function getReitElementsForPlanForUnAuthenticatedUser(planId: string): Promise<Array<ReitElement>> {
	const response = await apiRequest.get(`/ria/${planId}/reit-elements`);
	return response.data.map(
		(weightedReitElement: WeightedReitElementApi) =>
			new ReitElement(weightedReitElement.reitElement, weightedReitElement.weightedAllocation)
	);
}
